export enum VersionDiff {
    NEWER = 'NEWER',
    NONE= 'NONE',
    MINOR = 'MINOR',
    MAJOR = 'MAJOR',
}
